import { render, staticRenderFns } from "./familyCount.vue?vue&type=template&id=2ad582ad&"
import script from "./familyCount.vue?vue&type=script&lang=js&"
export * from "./familyCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports